export enum EOrderStatus {
  FINISHED = 'Finished',
  PROCESSING = 'Processing',
  CANCELED = 'Canceled'
}

export enum EOrderButtonAction {
  OPEN_TRANSIT = 'open_transit'
}

export interface IConcludedOrdersParams {
  page?: number;
  pageSize?: number;
  period?: string;
  type?: string[];
}

export interface IConcludedOrders {
  count: number;
  filters: IFilter[];
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  orders: IOrderGroup[];
  pageIndex: number;
  pageSize: number;
  periodFilter: IFilterOption[];
  totalCount: number;
  totalPages: number;
}

export interface IFilter {
  multiple: boolean;
  type: {
    label: string;
    value: string;
  };
  options: IFilterOption[];
}

export interface IFilterOption {
  label: string;
  value: string;
  checked: boolean;
}

export interface IOrderGroup {
  date: string;
  items: IOrderItem[];
}

export interface IOrderItem {
  value: IValueFormatted;
  icon: string;
  title: string;
  description: IOrderDescription | null;
  details: IOrderDetails;
}

export interface IValueFormatted {
  value: number;
  formatted: string;
}

export interface IOrderDescription {
  label: string;
  color: string;
}

export interface IOrderDetails {
  header: IOrderHeader;
  products: IOrderProductGroup[];
  alert: IOrderAlert | null;
  fees: IFeesDetails[] | null;
}

export interface IFeesDetails {
  label: string;
  value: string;
}

export interface IOrderHeader {
  title: string;
  icon: string;
  status: EOrderStatus;
  description: string;
  value: string | null;
  progress: {
    showProgress: boolean;
    value: number;
    startPoint: {
      label: string;
      value: string;
    };
    endPoint: {
      label: string;
      value: string;
    };
  } | null;
}

export interface IOrderProductGroup {
  title: string[];
  items: IOrderProduct[];
}

export interface IOrderProduct {
  name: string;
  orderId: string;
  value: string;
  status: {
    label: string;
    icon: string;
    type: 'positive' | 'negative' | 'info' | 'alert';
  };
  details: IProductDetails;
}

export interface IProductDetails {
  title: string;
  status: EOrderStatus;
  description: {
    color: string;
    label: string;
  };
  list: Array<{
    label: string;
    value: string;
  }> | null;
  button: {
    label: string;
    action: EOrderButtonAction;
  } | null;
}

export interface IOrderAlert {
  icon: string;
  title: string;
  status: string;
  description: string;
}

export interface IOpenedOrders {
  count: number;
  orders: IOrderItem[];
}
